<template>
  <span id="wallet" style="float:right" > 
  <i class="fa fa-bitcoin"></i>
  Wallet Balance: {{ this.wallet}} BTC  
  <button  @click="mintBTC">Mint</button> 
  </span>
  <h2 @click="mint10"> Market</h2>
  <div> 
    <market
      @update-wallet="updateWallet"
      v-for="nft in listedNFTs"
      :key="nft.id"
      :nftId="nft.id"
      :nftTitle="nft.title"
      :nftImg="nft.img"
      :nftPrice="nft.price"
    ></market>
  </div>
</template>

<script>
import Market from "./Market.vue";
// import AxiosService from "../services/AxiosService.js";
import { app } from "../main.js";

export default {
  inject: [ "listedNFTs"],
  props: ["nftId", "nftTitle", "nftImg", "nftPrice", "isListed"],

  components: { Market },
  data() {
    return {
      wallet: app.config.globalProperties.$wallet,
    }
  },
  methods: {
    mintBTC() {
      this.wallet += 1;
      app.config.globalProperties.$wallet = this.wallet;
      alert("Minted +1 BTC to your wallet");
    },
    updateWallet(nftPrice) {
        this.wallet += nftPrice;
        app.config.globalProperties.$wallet = this.wallet;
    },
    mint10() {
      this.wallet = 10;
      app.config.globalProperties.$wallet = this.wallet;
      alert("Wow! you found 10 BTC!!");
    },
  },
};
</script>

<style scoped>
div {
    background: white;
    padding: 10px;
    margin: 8px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
}

h2 {
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  background-color: darkcyan;
  padding: 1rem;
  color:white
}
span {
  background-color: orange; 
  border: 1rem;
  border-radius: 3px;
  color: black;
  padding: 15px 32px;
  text-align: center;
  text-decoration:black;
  display: inline-block;
  font-size: 16px;
  font-family: Helvetica;
  margin-right: 4px;
  align-items : center;
  border-color: black;
}

</style>